import React from 'react';
import { Collapse } from 'antd';
import Cin7Cache from 'pages/dashboard/Cin7Cache/Cin7Cache';
import KountaApiCache from 'pages/dashboard/KountaApiCache/KountaApiCache';
import KountaImport from 'pages/dashboard/ProductCache/KountaImport';
import CacheOverview from './CacheOverview';

const ProductCachePanel = () => (
  <div id="monday-integration-product-cache-panel">
    <CacheOverview />
    <Collapse>
      <Collapse.Panel header="Details" key="details">
        <div id="monday-integration-product-cache-details">
          <Cin7Cache />
          <KountaApiCache />
          <KountaImport />
        </div>
      </Collapse.Panel>
    </Collapse>
  </div>
);

export default ProductCachePanel;
